export default __webpack_public_path__ + "static/media/age-12-cloud.355209d2.svg";